import React, { useRef, useEffect, useState } from "react";
import { Button, Switch, Tooltip } from "antd";
import { FilePdfOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


const PrintWrapper = ({ children, title, layout = "portrait", showControls = true }) => {
  const printRef = useRef();

  const [showSignature, setShowSignature] = useState(false);


  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: ${layout === "landscape" ? "A4 landscape" : "A4 portrait"};
        margin: 10mm 12mm;
      }

      @media print {
        body {
          background: white !important;
          color: black !important;
        }

        #payslip-preview {
          box-shadow: none !important;
          background: white !important;
          border: 1px solid black !important;
          page-break-inside: avoid !important;
        }

        #payslip-preview * {
          color: black !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, [layout]);

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: title || "Document",
    removeAfterPrint: true,
  });

  // const handleDownloadPDF = async () => {
  //   const input = document.getElementById("payslip-preview");

  //   const canvas = await html2canvas(input, {
  //     scale: 2,
  //     useCORS: true,       
  //     allowTaint: true,   
  //     logging: true,
  //   });

  //   const imgData = canvas.toDataURL("image/png");

  //   const pdf = new jsPDF({
  //     orientation: layout === "landscape" ? "landscape" : "portrait",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //   pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  //   pdf.save(`${title || "Payslip"}.pdf`);
  // };

  const handleDownloadPDF = async () => {
  const input = printRef.current;

  if (!input) {
    console.error("Print ref not found");
    return;
  }

  // 🔍 find logos ONLY if they exist (payslip only)
  const urlLogo = input.querySelector(".logo-url");
  const b64Logo = input.querySelector(".logo-base64");
  const payslip = input.querySelector("#payslip-preview");
  const finalSettlement = input.querySelector("#final-settlement-print");

  // ✅ swap only if both exist
  if (urlLogo && b64Logo) {
    urlLogo.style.display = "none";
    b64Logo.style.display = "block";
  }

  console.log(urlLogo)
  console.log(b64Logo)
  console.log("URL hidden:", urlLogo?.style.display);
  console.log("B64 visible:", b64Logo?.style.display);
  console.log("B64 src:", b64Logo?.src.slice(0, 50));  

  //  hide elements
  const hiddenElements = input.querySelectorAll(".no-pdf");
  hiddenElements.forEach(el => (el.style.display = "none"));
  const originalMaxWidth = input.style.maxWidth;
  if(finalSettlement){
  input.style.width = "794px"; // A4 width equivalent
  input.style.maxWidth = "none";
  }

  try {
    await new Promise(requestAnimationFrame); // wait DOM update

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
    });

    if (!canvas || canvas.width === 0) {
      throw new Error("Canvas rendering failed");
    }

    const imgData = canvas.toDataURL("image/png");

    if (!imgData.startsWith("data:image/png")) {
      throw new Error("Invalid PNG data");
    }

    const pdf = new jsPDF({
      orientation: layout === "landscape" ? "landscape" : "portrait",
      unit: "mm",
      format: "a4",
    });

    const pdfWidth = finalSettlement ? 200 : pdf.internal.pageSize.getWidth();
    const pdfHeight = payslip ? (canvas.height * pdfWidth) / canvas.width : pdf.internal.pageSize.getHeight();

    // 🔥 scale to fit inside BOTH width & height
    const ratio = Math.min(
      pdfWidth / canvas.width,
      pdfHeight / canvas.height
    );

    const imgWidth = finalSettlement ? pdfWidth :  canvas.width * ratio;
    const imgHeight = finalSettlement ? (canvas.height * pdfWidth) / canvas.width : canvas.height * ratio;

    // center the content
    const x = (pdfWidth - imgWidth) / 2;
    const y = (pdfHeight - imgHeight) / 2;

    // pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
    pdf.save(`${title || "Document"}.pdf`);
  } catch (err) {
    console.error("PDF error:", err);
  } finally {
    // 🔁 revert logo swap safely
    if (urlLogo && b64Logo) {
      urlLogo.style.display = "block";
      b64Logo.style.display = "none";
    }
    // 🔁 restore elements
    hiddenElements.forEach(el => (el.style.display = ""));
  }
};


  return (
    <>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12
      }}>
        <div ></div>

{showControls && (
        <div 
        style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minWidth: "360px"
      }}
        >
          <Switch
          checked={showSignature}
          onChange={setShowSignature}
          checkedChildren="Signature"
          unCheckedChildren="No Signature"
        />

          <Button
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={handleDownloadPDF}
          >
            Download
          </Button>

          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            style={{ marginRight: 8 }}
          >
            Print
          </Button>

        </div>
    )}
      </div>

      <div id="print-content">
        {/* {React.cloneElement(children, { showSignature })} */}
        {React.isValidElement(children)
          ? React.cloneElement(children, { showSignature })
          : children}
      </div>

      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <div ref={printRef}>
          {/* {React.cloneElement(children, { showSignature })} */}
          {React.isValidElement(children)
            ? React.cloneElement(children, { showSignature })
            : children}

        </div>
      </div>
    </>
  );
};

export default PrintWrapper;
